module.exports = global["$"] = require("-!/var/www/html/node_modules/expose-loader/index.js?jQuery!./jquery.js");


//////////////////
// WEBPACK FOOTER
// ./~/jquery/dist/jquery.js
// module id = 26
// module chunks = 0